// Reconnect delays must be cancelled with their stream, including while a
// route is unmounting. Resolving on abort lets the loop exit on its guard.
export function waitForStreamRetry(delayMs, signal) {
  if (signal.aborted) return Promise.resolve();
  return new Promise(resolve => {
    const finish = () => {
      clearTimeout(timer);
      signal.removeEventListener('abort', finish);
      resolve();
    };
    const timer = setTimeout(finish, delayMs);
    signal.addEventListener('abort', finish, { once: true });
  });
}
